import React, { Component } from 'react';
import { connect } from 'react-redux';
import deliveryStyles from './Delivery.less';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import config from '../../config';

@connect(state => ({
  marginForPD: state.dashboardRoot.commonReducer.marginForPD,
}), {
})

export default class OpenPositions extends Component {

  static propTypes = {
      openPositionsData: PropTypes.array,
    };

    constructor(props) {
        super(props);
        this.state = {
            openPositions: []
        }
    }

    componentDidMount() {
        this.setState({
              openPositions: this.props.marginForPD.map(item => ({
                cmdty: item.suf_desc,
                position: Number(item.fc_amt).toLocaleString(navigator.language, { minimumFractionDigits: config.QuantityRoundOff })
              }))
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.marginForPD !== this.props.marginForPD) {
              this.setState({
                openPositions: nextProps.marginForPD.map(item => ({
                  cmdty: item.suf_desc,
                  position: Number(item.fc_amt).toLocaleString(navigator.language, { minimumFractionDigits: config.QuantityRoundOff })
                }))
              });
        }
    }

  render() {
    return (
      <div className={deliveryStyles.openPosBar}>
        <span className={deliveryStyles.openPositionsLabel}>
          {i18next.t("openPositions")}:
        </span>
        {this.state.openPositions?.map((op, idx) => (
          <div key={idx} className={deliveryStyles.openPosList}>
            <span className={deliveryStyles.cmdty}>{op.cmdty}</span>
            <span className={deliveryStyles.quantity}>{op.position}</span>
          </div>
        ))}
      </div>
    );
  }
}